import { render, staticRenderFns } from "./MarginSelector.vue?vue&type=template&id=a5a72174&scoped=true&"
import script from "./MarginSelector.vue?vue&type=script&lang=js&"
export * from "./MarginSelector.vue?vue&type=script&lang=js&"
import style0 from "./MarginSelector.vue?vue&type=style&index=0&id=a5a72174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a72174",
  null
  
)

export default component.exports